import { type SearchMultipleSelectionProps, FormSearchMultipleSelection } from '@shared/components';
import { useMemo } from 'react';

export type BaseSearchSelectionProps = Pick<SearchMultipleSelectionProps, 'options' | 'label'> & {
  name: string;
  value: { label: string; value: string }[];
};

export default function BaseSearchSelection(props: Readonly<BaseSearchSelectionProps>) {
  const { name, value, options, label } = props;

  const selectedOptions = useMemo(
    () =>
      value.map((item) => {
        const option = options.find((option) => option.value === item.value);
        return option ?? { label: item.label, value: item.value };
      }),
    [value, options],
  );

  return (
    <FormSearchMultipleSelection
      name={name}
      options={options}
      label={label}
      defaultValue={selectedOptions}
      sx={{ width: '100%' }}
      slotProps={{
        input: { placeholder: value.length === 0 ? 'แสดงทั้งหมด' : '' },
      }}
    />
  );
}
